<ng-container *ngFor="let breadcrumb of breadcrumbs$ | async; let last = last">
  <button mat-button [routerLink]="breadcrumb.url" *ngIf="!last">
    {{ breadcrumb.label }}
  </button>
  <button mat-button class="last" *ngIf="last">
    {{ breadcrumb.label }}
  </button>
  <span *ngIf="!last">/</span>
</ng-container>
